const popupCenter = ({ url, title, w, h }) => {
  // Fixes dual-screen position                             Most browsers      Firefox
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;
  const newWindow = window.open(
    url,
    title,
    `
      scrollbars=yes,
      width=${w / systemZoom},
      height=${h / systemZoom},
      top=${top},
      left=${left}
      `
  );

  if (window.focus) newWindow.focus();
};

module.exports = () => ({
  isOpen: false,
  linkCopied: false,
  shareConfigs: {
    facebook: {
      url: 'https://www.facebook.com/dialog/share?app_id=87741124305&display=popup&href=',
      width: 300,
      height: 500,
    },
    whatsapp: {
      url: 'https://api.whatsapp.com/send/?phone&text=',
      width: 300,
      height: 450,
    },
    twitter: {
      url: 'https://twitter.com/intent/tweet?url=',
      width: 300,
      height: 450,
    },
    linkedin: {
      url: 'https://www.linkedin.com/sharing/share-offsite/?url=',
      width: 300,
      height: 450,
    },
  },
  openDialog() {
    this.isOpen = true;
  },
  closeDialog() {
    this.isOpen = false;
  },
  copyLink() {
    /* Get the text field */
    const copyText = document.getElementById('share-input');

    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */
    navigator.clipboard.writeText(copyText.value);

    if (window.getSelection) {
      window.getSelection().removeAllRanges();
    } else if (document.selection) {
      document.selection.empty();
    }

    this.linkCopied = true;
    setTimeout(() => {
      this.linkCopied = false;
    }, 2000);

    console.log(`Copied the text: ${copyText.value}`);
  },
  getCurrentUrl() {
    return `${window.location.origin}/${
      this.$store.router.id ? this.$store.router.id : ''
    }`;
  },
  share(site) {
    const shareConfig = this.shareConfigs[site];
    const url = this.getCurrentUrl();
    popupCenter({
      url: shareConfig.url + encodeURIComponent(url),
      w: shareConfig.width,
      h: shareConfig.height,
    });
  },
});
